import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

export class OpenMemberRegistrationAction implements Action {
  constructor(
    public birthDate?: string,
    public email?: string,
    public address?: any,
    public token?:string,
    public type?:FamilyPlanTypes
  ) {}
}



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member-registration-dialog/family-plan-member-registration-dialog.action.ts